import { render, staticRenderFns } from "./watchVideo.vue?vue&type=template&id=9d51598a&scoped=true&"
import script from "./watchVideo.vue?vue&type=script&lang=js&"
export * from "./watchVideo.vue?vue&type=script&lang=js&"
import style0 from "./watchVideo.vue?vue&type=style&index=0&id=9d51598a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d51598a",
  null
  
)

export default component.exports